import { headers as defaultHeaders } from '@/config/axios';
import axiosRequest from '.';

const getAgentsByQuery = async (data) => (
  axiosRequest({
    url: '/v1/agent/agents',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const getArchivedAgentsByQuery = async (data) => (
  axiosRequest({
    url: '/v1/agent/archive',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const getFilteredAgentsByQuery = async (data = {}) => (
  axiosRequest({
    url: '/v1/agent/filter',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const getAgentById = async (data = {}) => (
  axiosRequest({
    url: '/v1/agent/agent',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const createAgent = async (data = {}) => (
  axiosRequest({
    url: '/v1/agent/create',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const updateAgent = async (data = {}) => (
  axiosRequest({
    url: '/v1/agent/update',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const archiveAgent = async (data = {}) => (
  axiosRequest({
    url: 'v1/agent/archive',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const archivedExpensesAgent = async (data = {}) => (
  axiosRequest({
    url: 'v1/agent/archivedExpensesAgent',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const archivedFeessAgent = async (data = {}) => (
  axiosRequest({
    url: 'v1/agent/archivedAdditionalFeesAgent',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const pushToArray = async (data = {}) => (
  axiosRequest({
    url: 'v1/agent/pushToArray',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const updateAgentItem = async (data = {}) => (
  axiosRequest({
    url: '/v1/agent/updateAgentItem',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const updateAgentItemBulk = async (data = {}) => (
  axiosRequest({
    url: '/v1/agent/updateAgentItemBulk',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

const reassignAutoAgent = async (data) => (
  axiosRequest({
    url: '/v1/agent/reassignAutoAgent',
    method: 'POST',
    data,
    headers: defaultHeaders,
  })
);

export {
  getAgentsByQuery,
  getArchivedAgentsByQuery,
  getFilteredAgentsByQuery,
  getAgentById,
  createAgent,
  updateAgent,
  archiveAgent,
  archivedExpensesAgent,
  pushToArray,
  archivedFeessAgent,
  updateAgentItem,
  updateAgentItemBulk,
  reassignAutoAgent,
};
